import React from 'react';
import ApplicationsListCard from '../card/ApplicationsListCard';
import { IApplication } from '../../utils';

interface IApplicationsListProps {
    applications: IApplication[];
    applicationListId: string;
}

const ApplicationsList: React.FC<IApplicationsListProps> = ({ applications, applicationListId }) => {
    return (
        <>
            {applications.map((application, index) => (
                <ApplicationsListCard key={`card-${index}`} application={application} applicationIndex={index} applicationListId={applicationListId}/>
            ))}
        </>
    );
};
export default ApplicationsList;
